import { useQuery } from "@apollo/client/react";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { constantsData } from "@/data";
import { getDistributionJobQuery, getDistributionReleaseUpcQuery } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useGetDistributionJob = (id) => {
    const { isAuthenticated } = useAuth0();

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { data, error, loading } = useQuery(getDistributionJobQuery, {
        skip: !isAuthenticated || !id,
        variables: { id },
    });

    const releaseId = data?.getDistributionJob?.releaseId;

    const {
        data: releaseData,
        error: releaseError,
        loading: releaseLoading,
    } = useQuery(getDistributionReleaseUpcQuery, {
        skip: !isAuthenticated || !releaseId,
        variables: { id: releaseId },
    });

    useEffect(
        () => {
            const currentError = error || releaseError;

            if (!currentError || loading || releaseLoading) return;

            displayErrorHandler(
                currentError.message === constantsData.failedToFetch
                    ? t("messages.networkFailure")
                    : currentError.message,
                dispatch,
                openAlert,
            );
        },
        [error, releaseError], // eslint-disable-line
    );

    return {
        data: data?.getDistributionJob && {
            ...data.getDistributionJob,
            upc: releaseData?.release?.upc,
        },
        loading: loading || releaseLoading,
    };
};

export default useGetDistributionJob;
